import {
  getValidationErrorKey as defaultGetValidationErrorKey,
  MIN_CHARS_EMAIL_ADDRESS,
  MIN_CHARS_MANDATORY_FIELD,
  MIN_MANDATORY_CHARS,
} from 'common/constants/form';
import { FieldName as AddressFieldName } from 'common/enums/address';
import type { ValidatorType } from 'common/enums/ValidatorType';
import type { ValidationMap } from 'common/types/form';
import {
  isValidEmailAddress,
  isValidName,
  isValidOrderNumber,
  isValidProductNumber,
} from 'common/utils/form/validation';
import { FieldName } from '../components/enums';
import type { ContactFormFieldSlice } from '../components/types';

const baseValidationMap: ValidationMap<FieldName> = new Map([
  [FieldName.FirstName, { length: MIN_MANDATORY_CHARS, validate: { pattern: isValidName } }],
  [FieldName.LastName, { length: MIN_MANDATORY_CHARS, validate: { pattern: isValidName } }],
  [FieldName.Phone, { length: MIN_CHARS_MANDATORY_FIELD }],
  [
    FieldName.EmailAddress,
    {
      length: MIN_CHARS_EMAIL_ADDRESS,
      validate: { pattern: isValidEmailAddress },
    },
  ],
  [
    FieldName.OrderNumber,
    {
      length: MIN_CHARS_MANDATORY_FIELD,
      validate: { pattern: isValidOrderNumber },
    },
  ],
  [
    FieldName.ProductName,
    { length: MIN_CHARS_MANDATORY_FIELD, validate: { pattern: isValidProductNumber } },
  ],
  [FieldName.Comment, { length: MIN_CHARS_MANDATORY_FIELD }],
  [FieldName.Images, { length: MIN_CHARS_MANDATORY_FIELD }],
  [FieldName.Channel, { length: MIN_CHARS_MANDATORY_FIELD }],
]);

const getValidationRulesForSlice = (slice: ContactFormFieldSlice) => {
  const { length, validate } = baseValidationMap.get(slice.fieldName) ?? {};

  return [
    slice.fieldName,
    {
      ...(slice.required && { length }),
      validate,
    },
  ] as const;
};

export const getValidationMap = (slices: ContactFormFieldSlice[]): ValidationMap<FieldName> =>
  new Map(slices.map(getValidationRulesForSlice));

export const getValidationErrorKey = (fieldName: FieldName, validatorName: ValidatorType) => {
  const mappedFieldName = {
    [FieldName.FirstName]: AddressFieldName.FirstName,
    [FieldName.LastName]: AddressFieldName.LastName,
    [FieldName.Phone]: AddressFieldName.Phone,
    [FieldName.EmailAddress]: AddressFieldName.EmailAddress,
    [FieldName.OrderNumber]: FieldName.OrderNumber,
    [FieldName.ProductName]: FieldName.ProductName,
    [FieldName.Comment]: FieldName.Comment,
    [FieldName.Images]: FieldName.Images,
    [FieldName.Channel]: FieldName.Channel,
  }[fieldName];

  return defaultGetValidationErrorKey(mappedFieldName, validatorName);
};
